// extracted by mini-css-extract-plugin
export default {"handleBox":"handleBox-j7ZJq","inputMode":"inputMode-KIiSK","path":"path-iW1C_","close":"close-ko_Os","changed":"changed-ZMpqj"};